import { useQuery } from "@tanstack/react-query";
import type { Environment } from "../../../types";
import type { ForgePool, ForgePoolsResponse } from "../types";
import { getApiBase } from "../../../lib/remote-config";

export const FORGE_POOLS_QUERY_KEY = "wp:forge-pools";

export function useForgePools(
  env: Environment,
  walletAddress: string,
  enabled = true,
) {
  const hasAddress = enabled && !!walletAddress;

  const { data, ...rest } = useQuery<ForgePool[]>({
    queryKey: [FORGE_POOLS_QUERY_KEY, env, walletAddress],
    queryFn: async () => {
      const baseUrl = await getApiBase("bondingCurve", env);
      const res = await fetch(
        `${baseUrl}/v1/users/${walletAddress}/pools`,
        { cache: "no-store" },
      );
      if (!res.ok) throw new Error(`forge pools fetch failed: ${res.status}`);
      const json: ForgePoolsResponse = await res.json();
      return json.data?.items ?? [];
    },
    enabled: hasAddress,
    staleTime: 0,
  });

  const pools = data ?? [];

  return {
    pools,
    isEmpty: pools.length === 0,
    ...rest,
  };
}
